import { render, staticRenderFns } from "./RegisterBottomTeaser.vue?vue&type=template&id=b01f477c&scoped=true&"
import script from "./RegisterBottomTeaser.vue?vue&type=script&lang=js&"
export * from "./RegisterBottomTeaser.vue?vue&type=script&lang=js&"
import style0 from "./RegisterBottomTeaser.vue?vue&type=style&index=0&id=b01f477c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01f477c",
  null
  
)

export default component.exports